import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FDCM } from '../fastDeliveryCargoManagement.classes';

interface TabContainerProps {
  selectedTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const TabContainer: React.FC<TabContainerProps> = ({ selectedTab, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <Box className={FDCM.tabsWrap} sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs
        className={FDCM.tabsRoot}
        value={selectedTab}
        onChange={onTabChange}
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: '#00B8F4',
            height: 3
          },
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '1.1rem',
            minWidth: 150,
            padding: '12px 24px',
            '&.Mui-selected': {
              color: '#00B8F4',
              fontWeight: 600
            },
          },
        }}
      >
        <Tab className={FDCM.tabDeliveryList} label={t('fastDeliveryCargoManagement.deliveryList')} />
        <Tab className={FDCM.tabBulkUpload} label={t('fastDeliveryCargoManagement.bulkUpload')} />
      </Tabs>
    </Box>
  );
};

export default TabContainer; 